var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _path8, _g3, _rect, _rect2, _rect3, _rect4, _rect5, _path9, _path10, _path11, _path12, _g4, _g5, _path13, _g6, _defs2, _g7, _path14, _path15, _path16, _path17, _path18, _g8, _path19, _g9, _g10, _defs3, _path20, _defs4, _path21, _defs5, _defs6, _defs7, _path22, _path23, _path24, _path25, _path26, _path27, _defs8, _defs9, _defs10, _path28, _path29, _rect6, _g11, _path30, _defs11, _path31, _defs12, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCellphoneSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1511 1454",
    style: {
      enableBackground: "new 0 0 1511 1454"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000060710728514054661720000010049782010166222992_);fill:#6BBFD6;}\n\t.st1{clip-path:url(#SVGID_00000060710728514054661720000010049782010166222992_);}\n\t.st2{opacity:0.2;}\n\t.st3{fill:#131313;}\n\t.st4{fill:#00B7B1;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#41486D;}\n\t.st7{fill:#294950;}\n\t.st8{fill:none;stroke:#00ACE4;stroke-width:4.3662;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#00ACE4;stroke-width:4.3662;stroke-miterlimit:10;stroke-dasharray:22.1345,22.1345;}\n\t.st10{fill:none;stroke:#00ACE4;stroke-width:4.3662;stroke-miterlimit:10;stroke-dasharray:21.831;}\n\t.st11{fill:#FFA45D;}\n\t.st12{fill:#4C4C4C;}\n\t.st13{opacity:0.29;}\n\t.st14{fill:url(#SVGID_00000119092745329400261520000011238885542996359082_);}\n\t.st15{fill:#BDBDBD;}\n\t.st16{fill:#FFD0A4;}\n\t.st17{fill:#FFC799;}\n\t.st18{fill:#ADACAC;}\n\t.st19{fill:#808080;}\n\t.st20{opacity:0.58;}\n\t.st21{fill:#E0BFA1;}\n\t.st22{fill:#261B14;}\n\t.st23{fill:#FF6C6C;}\n\t.st24{clip-path:url(#SVGID_00000039819922457909584250000004468965050616088712_);}\n\t.st25{fill:#E8807E;}\n\t.st26{fill:#68452D;}\n\t.st27{opacity:5.000000e-02;fill:#1C1C1B;}\n\t.st28{fill:#482E1E;}\n\t.st29{fill:none;}\n\t.st30{opacity:0.2;fill:#3F280D;}\n\t.st31{fill:#57453F;}\n\t.st32{opacity:5.000000e-02;}\n\t.st33{fill:#804F18;}\n\t.st34{opacity:5.999800e-02;}\n\t.st35{clip-path:url(#SVGID_00000067235159947338652330000006336291378766864273_);fill:#020102;}\n\t.st36{fill:#492113;}\n\t.st37{clip-path:url(#SVGID_00000142862357899236640970000018066129648026671270_);fill:#020102;}\n\t.st38{opacity:0.6;}\n\t.st39{clip-path:url(#SVGID_00000118366820602056355760000011257574383334615480_);}\n\t.st40{filter:url(#Adobe_OpacityMaskFilter);}\n\t\n\t\t.st41{clip-path:url(#SVGID_00000029768565209343155160000000293782400735649412_);fill:url(#SVGID_00000166656579546619896560000007525290516758731173_);}\n\t\n\t\t.st42{clip-path:url(#SVGID_00000029768565209343155160000000293782400735649412_);mask:url(#SVGID_00000032644708109916548270000006889787321410471083_);fill:url(#SVGID_00000161630081297827204060000006604928686915054209_);}\n\t.st43{fill:#D3A58E;}\n\t.st44{fill:#F8D1B0;}\n\t.st45{fill:#1E1D1D;}\n\t.st46{clip-path:url(#SVGID_00000099623717326982352810000005855093055186927290_);}\n\t.st47{filter:url(#Adobe_OpacityMaskFilter_00000036953332926302158330000001441846556023343505_);}\n\t\n\t\t.st48{clip-path:url(#SVGID_00000006670663074746470230000009427308110647707017_);fill:url(#SVGID_00000112628693831894267000000016169260411329079682_);}\n\t\n\t\t.st49{clip-path:url(#SVGID_00000006670663074746470230000009427308110647707017_);mask:url(#SVGID_00000155866346246278845440000001078587551800953275_);fill:url(#SVGID_00000152983108092471240020000008762316048014902444_);}\n\t.st50{fill:#303030;}\n\t.st51{fill:#4B4B4B;}\n\t.st52{fill:#72B500;}\n\t.st53{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st54{opacity:0.35;}\n\t.st55{clip-path:url(#SVGID_00000055708457991813923130000009892423783346977193_);fill:#C2C0BF;}\n\t.st56{clip-path:url(#SVGID_00000008120544371588718510000010336167750015292835_);fill:#C2C0BF;}\n\t.st57{fill:#F6DDC9;}\n\t.st58{fill:#F9EAE1;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M1034.4,408.7C1290.3,91.3,793,12.9,661.4,44.2c-79.3,18.9-92.7,105.9-90,175.4 c-269.5,51.3-441.8,329.1-522.4,604C-41.6,1132.1,283.8,1424,605.4,1424c321.5,0,776.6-10.7,776.6-332.3 C1382,892.1,1228.1,600.8,1034.4,408.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129167871408580394230000000121170530876871335_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129167871408580394230000000121170530876871335_)",
      fill: "#6BBFD6"
    },
    d: "M1382,1091.8 c0,321.5-455.1,332.3-776.6,332.3c-321.5,0-647-292-556.4-600.5c89.3-304.3,291-612.4,612.5-612.4 C982.9,211.2,1382,770.3,1382,1091.8z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000129167871408580394230000000121170530876871335_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M683.3,2593.3c115,0,211.1,9.5,235.4,22.3c34.9-2.3,75.2-3.7,118-3.7c133.3,0,241.4,12.8,241.4,28.7 s-108.1,28.7-241.4,28.7c-115,0-211.1-9.5-235.4-22.3c-34.9,2.3-75.2,3.7-118,3.7c-133.3,0-241.4-12.8-241.4-28.7 S550,2593.3,683.3,2593.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1080.5,2643.5c0,0,1.4,13.4-1.4,17.3s-39.2,17.2-69.4,18.1c-27.7,0.8-81.7-14.5-83.4-18.9 c-1.6-4.4-4.4-13.4-3.6-15.4c0.8-1.9,9.3-16.2,9.3-16.2s29.6-27.4,63.1-29.6S1069.2,2628.4,1080.5,2643.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M951.6,2583.8c0,0-21.1,24.9-22.2,36.2s2.1,25.1,2.1,25.1s23.5,12.3,72,12.3c42.9,0,72.4-11.9,72.4-11.9 c3.3-22.6-4.9-49.4-23-54.7c-16.1-4.8-40.4-54.1-40.4-54.1l-46.3,4.5L951.6,2583.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M734.8,2505.8c0,0-0.8,32.5-8.6,42c0,0,25.9,11.1,42,11.1c16,0,38.7-1.6,38.7-1.6s2.9-32.1-6.2-43.2 S734.8,2505.8,734.8,2505.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M806,2584.8c0,0,8.2,2.9,8.2,7.8s0.4,16,0.4,16s-36.2,9.9-43.2,17.7s-65.8,28.4-85.2,29.2 c-19.3,0.8-120.1,9.9-135.4-12.8c-15.2-22.6,7.4-25.5,7.4-25.5L806,2584.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M729.9,2523.9c0,0-15.2,22.7-38.1,33.1c-23,10.4-108.5,24-123.9,41c-20.3,22.4-21.1,41.4,30.1,42.8 c0,0,42.4,4.9,90.4-3.5c48-8.4,85-31,90.2-34.1c5.2-3.1,31.3-12.5,31.3-12.5s9-18-1.4-53.7 C785.9,2531.7,735.5,2544.3,729.9,2523.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M617.5,705.6c0,0-25,185.9-48.9,239.8l96.5,29c0,0,88.3-297.5,14.8-330.1 C628.3,648.8,617.5,705.6,617.5,705.6z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1029.1,1404.5c-124.5-114.6-249.6-71.7-383.1-9.6c0.7,5.2-2.4,11.3,10.8,57.2c3.4,52.1,6.5,552,6.5,552 l69,509.1c31.3,17.6,35.4-4.1,76,5.6l-61.5-509.6c0,0,9.9-335.1,11.4-474.6c6.9,0.5,96.9,7.4,123.5,6.9 c11.1,96.9,12,284.8,15,460.2l56.1,553.3c14.5-16.8,58.7-14.2,78.9,0.4l-42.3-559.2c0,0,15.9-343.1,10.3-469.8 C1011.2,1501.5,1032.1,1477,1029.1,1404.5z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M746.1,2485.3c0-0.4-0.5-4.2-1.3-10.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M741.8,2452.6c-14.6-108.6-61.7-449.4-61.7-449.4l-6.1-465"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 673.8,
    y1: 1527.2,
    x2: 673.6,
    y2: 1516.3
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M943.5,1533.4c0,0-3.3,424.8-8,442.2c-4.6,17.4,35.9,543.9,35.9,543.9"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M648.3,1378.4c31.6,10.9,130.8,43.3,196.5,43.3c62.9,0,147.7-18.8,179.6-26.4c6.6,12.4,10.2,26,10.2,40.9 c0,0.4,0,0.7,0.1,1.1c-23.7,12.8-84,33.5-195.9,30.8c-119.6-2.9-165.9-29.2-189.3-39.7c-2.5-18.1-3-30.9-3.4-33.6 C646,1389.1,646.8,1383.6,648.3,1378.4z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 992.5,
    y: 1406.3,
    transform: "matrix(-0.9906 0.1365 -0.1365 -0.9906 2192.9827 2719.5388)",
    className: "st12",
    width: 21.4,
    height: 57.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 918.1,
    y: 1420.4,
    transform: "matrix(-0.9986 5.293098e-02 -5.293098e-02 -0.9986 1932.9446 2846.9856)",
    className: "st12",
    width: 21.4,
    height: 57.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 659.3,
    y: 1392.3,
    transform: "matrix(-0.9943 -0.1069 0.1069 -0.9943 1184.1578 2905.4441)",
    className: "st12",
    width: 21.4,
    height: 57.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 709.1,
    y: 1414.9,
    transform: "matrix(-0.9943 -0.1069 0.1069 -0.9943 1281.0212 2955.8965)",
    className: "st12",
    width: 21.4,
    height: 57.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 758.2,
    y: 1421.9,
    transform: "matrix(-0.9993 -3.637283e-02 3.637283e-02 -0.9993 1559.4673 2932.2107)",
    className: "st12",
    width: 96.4,
    height: 60
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179612962955880923360000014722931719052994481_",
    gradientUnits: "userSpaceOnUse",
    x1: -10459.4629,
    y1: 711.6148,
    x2: -10458.915,
    y2: 711.6148,
    gradientTransform: "matrix(1 0 0 1 11485.4307 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1AB26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1AB26",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179612962955880923360000014722931719052994481_)"
    },
    d: "M1026,711.7c0.2,0,0.4-0.1,0.5-0.1 C1026.3,711.6,1026.2,711.6,1026,711.7L1026,711.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M646,1394.8c0,0,52.2,40.4,211.9,40.4s171.2-30.7,171.2-30.7s-35.4-105-20.8-314.2 c19.8-283.1,38.6-406.4-39.2-458.4l-305,40.9C643.9,1077.9,646,1394.8,646,1394.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M664.1,672.8c21.1,39.5,107.6,75,132.5,75c24.9,0,177.2-80.9,172.5-115.8c-15.4-113.6,3.3-140.7,16.2-233.9 c12.9-93.2,1.1-119.8,1.1-119.8c4.3-88.3-93.3-153-190.2-135.7c-96.2,11.5-144.7,63.9-143,164.3c1.2,66-12.9,163,13.4,311.5 C668.9,631.8,664.1,672.8,664.1,672.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M796.6,747.7c24.9,0,177.2-80.9,172.5-115.8c-12.2-90.2-3-125.9,7.8-183.4l-0.2-21.7c0,0-57,74.2-57,112.2 s-14.3,187.3-125.5,187.3c-79.1,0-114.9-39.9-129-63c-0.6,5.6-1,9.4-1,9.4C685.2,712.3,771.7,747.7,796.6,747.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M857.9,1435.2c159.8,0,171.2-30.7,171.2-30.7s-35.4-105-20.8-314.2c9.4-133.6,21.6-225.2,23.7-290.1 l-4.1-47.1c0,0-70.1,341.4-68,405.5s-25.2,78.9-10.5,89.4c14.7,10.5,40,99.1,31.5,122.2c-8.4,23.1-95.7,34.7-177.7,34.7 s-144.1-29.4-153.5-66.2c-2.4-9.4-5.1-19.3-7.8-29c2.1,54.4,4,85.1,4,85.1S698.2,1435.2,857.9,1435.2z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M721.7,116.3c1.4-0.2,2.1-0.3,2.1-0.3S723,116,721.7,116.3z"
  }))), /*#__PURE__*/React.createElement("g", null, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M737.7,555.7c14.1,9.1,54.6,7.2,66.9-0.9C804.5,554.9,775.5,580.2,737.7,555.7"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M690.4,482.2c7.3-13.1,24.2,4.3,52.8,7.5c28.5,3.2,145.2-30,135.5,8.7c-9.3,36.9-97.3,59.4-126.3,53 C698.8,539.4,687.1,488.1,690.4,482.2"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M866.7,516.8c-14.7-0.3-36.7-0.1-47.9,2.6c-24.3,6-27.2,9.6-30.4,11.1c0-1.7,4.7-4.9,12.3-7.7 c-2.1-2.2-12-3-25.9-1c-20.2,2.8-41.4,12.2-51.5,17.2c7.9,5.3,17.5,9.7,28.9,12.3C776.1,556.7,839.5,542.5,866.7,516.8z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000158740850791034999740000004189297438928227717_",
    d: "M690.4,482.2c7.3-13.1,24.2,3.3,52.8,6.5 c28.5,3.2,145.2-29,135.5,9.7c0,0-67.2,16.7-113.8,14.1C708.7,509.4,687.1,488.1,690.4,482.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000027595126023628179830000000275987149138980513_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158740850791034999740000004189297438928227717_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000027595126023628179830000000275987149138980513_)"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M745.5,484.2c-17.1-1.9-29.6-8.6-38.8-10.8c-0.4,1.8-0.1,3.3,2.2,4.8c5.2,3.2,19.9,9.9,33.3,10.7 c13.3,0.8,89.9,1.2,101.9-2.3c5-1.5,11-3.4,15.1-11.1C828.3,471.8,763.8,486.2,745.5,484.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M706.8,476.2c0,0,1,7.2,1.8,9.4c1.4,3.7,3.8,5.8,6.8,6.9c1.7,0.6,6.1,1.1,9.7,0.4c3-0.6,4.2,4.6,8.5,6.7 c4.9,2.4,12.9,1.9,16.1,1.6c3.2-0.3,9.3,3.2,14.2,2.9c7.9-0.4,14.8-4.3,15.9-3.8c9.3,3.9,19.8,0.6,23.4-3.6 c9,4,22.1,0.7,25.8-3.7c5,1.4,15.8,0.5,18.6-1.8c2.5-2.1,7.6-10.6-2.2-13.3c-3.9-1.1-13.5,3.9-16.2,4.9 c-2.6,1-11.3-2.6-14.9-2.4c-7.6,0.3-9.9,4.6-12.6,5.2c-2.7,0.5-5.7-2.7-10.1-3c-12.1-0.9-13.5,3.9-16.2,4 c-2.8,0.1-8.8-1.5-12.2-2c-6-0.9-13.5,3-15.5,3.1c-1.8,0.1-5.8-3.1-11.6-3.8c-3.5-0.4-8.6,1.7-10.4,0.8 C722.1,482.9,719.1,475.6,706.8,476.2"
  })))))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M653.8,281c0,0-9.7-36.9-7.7-58.4c2-21.5,9.2-68.7,9.2-68.7l8.2,12.3l59.4-60.5l-1,26.6l57.4-49.2 l-5.1,22.5c0,0,51.2-19.5,48.2-28.7c-3.1-9.2,10.2,24.6,10.2,24.6s49.2,12.3,62.5-3.1s21.5,7.2,21.5,7.2s26.6,34.8,54.3,28.7 c27.7-6.1,31.8,1,31.8,1s-3.1,47.1,0,53.3c3.1,6.1,30.7,10.2,30.7,10.2s3.1-1-8.2,18.4c-11.3,19.5,14.3,13.3,7.2,38.9 s9.2,61.5-4.1,84c-13.3,22.5-12.3,88.1-24.6,103.5c-12.3,15.4-28.7,49.2-34.8,46.1c-6.1-3.1-34.3-141.4-24.3-209.1 c0,0,17.4-88.2-136.3-88.2S652.5,265.6,653.8,281z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M968.9,468.1c32.6-27.9,44.3-87.4,7.3-97.7c-37-10.3-40.6,73.3-40.6,73.3S913.9,515.3,968.9,468.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M947.9,430c0,0,3.3-7.3,9.5-6.8c6.1,0.4,14.3,3.5,22.9-15.7c0,0-0.3-6.7-5.7-9.4c-5.3-2.7-10.2-3-14.6,3.9 C955.6,408.9,946.2,421,947.9,430z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M956.6,354.1c-1.4,1.9,11.9-73.4,7.3-98C959.3,231.5,992.8,304.2,956.6,354.1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M997.4,278.2c0,0-15.3,70.1-26.8,80.3c0,0,20.2-9.5,24.9-33.3C1000.4,300.8,997.4,278.2,997.4,278.2z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M655.3,153.9c0,0-0.1,1-0.4,2.6C655,155.5,655.1,154.6,655.3,153.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M653.8,281c0,0-9.7-36.9-7.7-58.4c1.8-18.5,7.3-55.9,8.8-66.1c-1.8,16.8,4.1,73.1,6.6,95.1 C654.5,264.7,653.3,276,653.8,281z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M774.2,105.7c0,0,51.2-19.5,48.2-28.7c0,0,0.5,0.8,1.2,2.1c0.4,1,0.8,2,1.3,3.2c2.2,6.7,2.8,18.4-14.1,28 c-25.1,14.3-51.8,36.1-61.2,33.8C773.7,121.9,774.2,105.7,774.2,105.7z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M825.7,306.3c7.5-2.7,19.9-4.6,32.6-4.3c19.6,0.6,40.6,13.2,40.6,13.2s26.6,16.5,22.2,19.2 c-2.1,1.3-35.9-16.3-48.2-18.9s-45.9,2.9-48.6,1.7C821.8,316,817.8,309.2,825.7,306.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M728.5,308.3c-5.8-3.1-17-3.9-26.6-4.2c-14.9-0.4-28.7,9.3-28.7,9.3s-19.5,15-15.9,17.8 c1.7,1.3,26.5-14.3,35.8-16.2s35.2,5.2,37.1,4.2C732,318,734.7,311.5,728.5,308.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9997 -2.535528e-02 2.535528e-02 0.9997 -9.431 17.9961)",
    className: "st31",
    cx: 704.9,
    cy: 380.9,
    rx: 36.3,
    ry: 32.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9997 -2.535528e-02 2.535528e-02 0.9997 -9.4726 18.0481)",
    className: "st5",
    cx: 707,
    cy: 382.6,
    rx: 35,
    ry: 31.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M747.8,407.2l2,26.9l-78.6,5.7c0,0-0.3-23.2-1.8-24.4s8.9-12.5,38.8-14.6 C737.9,398.6,747.8,407.2,747.8,407.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M738.4,413c0,0-23.8-7.7-39.8-2.1s-34.3,11.5-16.7,10.3C699.6,419.9,740.9,418.8,738.4,413z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(3.863173e-02 -0.9993 0.9993 3.863173e-02 442.3882 1230.7056)",
    className: "st31",
    cx: 860.8,
    cy: 385.4,
    rx: 33.1,
    ry: 36.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(3.863173e-02 -0.9993 0.9993 3.863173e-02 438.7639 1230.2388)",
    className: "st5",
    cx: 858.7,
    cy: 387.1,
    rx: 32,
    ry: 35
  })), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M862.5,380.5c0.1-2.7,2.6-4.9,6.4-6c-2.1-2-4.9-3.2-8-3.4c-6.9-0.3-12.6,5.1-12.9,11.9 s5.1,12.6,11.9,12.9c5.5,0.2,10.2-3.1,12.1-8C866.4,387,862.4,383.9,862.5,380.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M716.9,376.6c0.1-3.1,3.1-5.7,7.4-7c-2.5-2.3-5.7-3.8-9.3-3.9c-8-0.3-14.7,5.9-15,13.9 c-0.3,8,5.9,14.7,13.9,15c6.4,0.2,11.9-3.6,14.1-9.3C721.5,384.2,716.7,380.6,716.9,376.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M817.6,411.2l-2.3,26.9l78.5,6.8c0,0,0.6-23.2,2.1-24.4c1.5-1.3-8.8-12.6-38.6-15.2 S817.6,411.2,817.6,411.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M826.9,417.1c0,0,23.9-7.3,39.8-1.6s34.2,11.9,16.5,10.5C865.6,424.5,824.3,422.9,826.9,417.1z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M988.2,700.6c-57.3,0,13.7,99.2,41.5,293.9c5.5,38.6,25.7,124.7,24.9,166.4c12.9,51.5,57.4,25.5,57.5,9.4 C1112.5,1093,1070.6,700.6,988.2,700.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1054.6,1160.9c-18.9,97.2-48,315.7-48,315.7l29.6,28c0,0,68.1-288.1,75.9-334.2 C1114.5,1124.7,1063.2,1117.2,1054.6,1160.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1049.4,1549c2.5-10.7,3.2-23.2,1.3-37.3c-7.5-56-76.6-55.2-77.5,51.7l-0.6,0.4 c-1.4,20.6,13.1,98.7,20,98.9c5.1,0.1,9.1-3.2,9.3-9.8c4.1,19.4,8.7,35.5,11.8,35.6c6.9,0.2,11.9-5.8,8.1-18.1 c-1.9-6-3.2-27.8-4-49.4c6.4,28.4,16.3,61.2,20.4,60.8c6.3-0.5,10.3-7,5.8-18.8c-2.5-6.5-6-32.7-8.6-56.2 c6.3,27.2,14.5,55,18.6,54.7c6.9-0.5,11.3-6.9,6.3-18.8C1056.1,1632.6,1050.8,1571.4,1049.4,1549z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M953.9,756.6c0,0,57.2,195.6,57.2,259.6l108.7-13.7c0,0-43.5-334.3-130.8-334.3 C939.5,695.4,953.9,756.6,953.9,756.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st34"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000039822162116296606440000010490152964426624703_",
    x: 390.8,
    y: 1042.3,
    width: 13.8,
    height: 48.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140692495523808120510000014111300959705594538_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039822162116296606440000010490152964426624703_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000140692495523808120510000014111300959705594538_)",
      fill: "#020102"
    },
    d: "M404.6,1090.7 c-12-10.6-13.8-48.4-13.8-48.4"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M390.2,1041.5c0,0-14,12.8-15.1,26.6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st34"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000063618968919546393140000003729661827203077512_",
    x: 377.9,
    y: 1041.5,
    width: 12.2,
    height: 28
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000130648854326706734640000014005615172593639824_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000063618968919546393140000003729661827203077512_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000130648854326706734640000014005615172593639824_)",
      fill: "#020102"
    },
    d: "M390.2,1041.5 c0,0-12.5,14.2-12.2,28"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M406.7,1089c-12.6-9.9-16.6-47.5-16.6-47.5"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st38"
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000058566971701756269010000010219252790532887179_",
    x: 659.1,
    y: 1211,
    width: 36.2,
    height: 71.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145747979815219227780000003503233405683213243_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000058566971701756269010000010219252790532887179_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000145747979815219227780000003503233405683213243_)"
    }
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000041273646231310554290000016391257034985927816_",
    d: "M659.1,1277.1c3.5-5,6.9-10.4,10.2-15.7 c3.3-5.4,6.5-10.8,9.5-16.3c3.1-5.5,6-11.1,8.7-16.8c2.8-5.7,5.3-11.5,7.7-17.3c-1.7,6.1-3.4,12.2-5.5,18.3 c-2,6-4.2,12-6.5,18c-2.3,5.9-4.8,11.8-7.4,17.7c-2.6,5.9-5.4,11.6-8.4,17.4L659.1,1277.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122680892746842309550000009439769007944015261_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041273646231310554290000016391257034985927816_",
    style: {
      overflow: "visible"
    }
  })), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 659.1,
    y: 1211,
    width: 36.2,
    height: 71.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 659.1,
    y: 1211,
    width: 36.2,
    height: 71.3,
    id: "SVGID_00000157281165633512874720000012897691203220529831_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st40"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058581743575162041740000001739531024222260671_",
    gradientUnits: "userSpaceOnUse",
    x1: 661.3676,
    y1: 1069.3278,
    x2: 664.6764,
    y2: 1069.3278,
    gradientTransform: "matrix(-12.3312 0 0 12.3312 8855.3193 -11939.4648)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 659.1,
    y: 1211,
    style: {
      clipPath: "url(#SVGID_00000122680892746842309550000009439769007944015261_)",
      fill: "url(#SVGID_00000058581743575162041740000001739531024222260671_)"
    },
    width: 36.2,
    height: 71.3
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039120276249236402220000017451743581788975245_",
    gradientUnits: "userSpaceOnUse",
    x1: 661.3676,
    y1: 1069.3278,
    x2: 664.6764,
    y2: 1069.3278,
    gradientTransform: "matrix(-12.3312 0 0 12.3312 8855.3193 -11939.4648)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8E8E8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5E4E3"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 659.1,
    y: 1211,
    style: {
      clipPath: "url(#SVGID_00000122680892746842309550000009439769007944015261_)",
      mask: "url(#SVGID_00000157281165633512874720000012897691203220529831_)",
      fill: "url(#SVGID_00000039120276249236402220000017451743581788975245_)"
    },
    width: 36.2,
    height: 71.3
  })))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M235.5,1069.8c17.3-13.6,42.3-10.7,55.9,6.5l81.4,102.9c1.7,2.1,40.7,50.5,41.9,52.8l-62.1,50.4 c-2.2-1.8-123.7-156.7-123.7-156.7C215.3,1108.5,218.2,1083.4,235.5,1069.8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M215.9,945.6c16.6-14.5,41.7-12.8,56.2,3.8l86.3,98.8c1.8,2,43.1,48.5,44.4,50.7l-58.1,51.9 c-2.3-1.7-44.3-48-46.3-50.2l-86.3-98.8C197.6,985.2,199.3,960,215.9,945.6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M219.4,829.4c17.6-15,44-12.9,59,4.6l89.5,104.8c1.8,2.1,44.7,51.4,46.1,53.7l-61.6,53.9 c-2.4-1.8-46-50.9-48.1-53.3l-89.5-104.8C199.8,870.8,201.8,844.4,219.4,829.4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M288.4,843.9c15.1,17.8,41.7,20.1,59.5,5c17.8-15,20.1-41.7,5-59.5L263.2,683c-15.1-17.8-41.7-20.1-59.5-5 c-17.8,15-20.1,41.7-5,59.5L288.4,843.9z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M587.3,1028.6c-3,23.1,13.2,44.4,36.4,47.4c23.1,3,16.6-49.6,19.6-72.8l45.9-101.6 c3-23.1-13.2-44.3-36.4-47.4c-23.1-3-44.4,13.3-47.4,36.4L587.3,1028.6z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M384.1,628.1c0.3,2.4,2.6,4.1,5,3.8l57.9-8.1c2.4-0.3,4.1-2.6,3.8-5c-0.3-2.4-2.6-4.1-5-3.8l-57.9,8.1 C385.4,623.4,383.7,625.7,384.1,628.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000059272019843927799100000003637452355853895305_",
    x: 562,
    y: 1088.5,
    width: 9.8,
    height: 10.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155852201015116140250000003913060839483960757_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000059272019843927799100000003637452355853895305_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000155852201015116140250000003913060839483960757_)"
    }
  }, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000151538632839250184200000001468630195197853603_",
    d: "M562,1088.5c10.6,0.3,9.8,10.9,9.8,10.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008114731201602838070000004215597351741218989_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000151538632839250184200000001468630195197853603_",
    style: {
      overflow: "visible"
    }
  })), _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000049208732612502538050000009366479532893164721_",
    filterUnits: "userSpaceOnUse",
    x: 558.7,
    y: 1085.3,
    width: 17.1,
    height: 17.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 558.7,
    y: 1085.3,
    width: 17.1,
    height: 17.3,
    id: "SVGID_00000049943011848805000580000017629583865269782705_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000049208732612502538050000009366479532893164721_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130622322668899978230000010955960091828829849_",
    gradientUnits: "userSpaceOnUse",
    x1: 482.2388,
    y1: 871.7888,
    x2: 485.5479,
    y2: 871.7888,
    gradientTransform: "matrix(-0.8996 -2.6869 2.6869 -0.8996 -1339.4615 3179.4885)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000008114731201602838070000004215597351741218989_)",
      fill: "url(#SVGID_00000130622322668899978230000010955960091828829849_)"
    },
    points: " 575.8,1098.3 571.5,1085.3 558.7,1089.6 563.1,1102.6  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041286396066513823340000005460709557458262915_",
    gradientUnits: "userSpaceOnUse",
    x1: 482.2388,
    y1: 871.7888,
    x2: 485.5479,
    y2: 871.7888,
    gradientTransform: "matrix(-0.8996 -2.6869 2.6869 -0.8996 -1339.4615 3179.4885)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EECEAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EECEAE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000008114731201602838070000004215597351741218989_)",
      mask: "url(#SVGID_00000049943011848805000580000017629583865269782705_)",
      fill: "url(#SVGID_00000041286396066513823340000005460709557458262915_)"
    },
    points: " 575.8,1098.3 571.5,1085.3 558.7,1089.6 563.1,1102.6  "
  })))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M323.3,1273.5c2.4,17,18.1,28.9,35.1,26.5l304.4-42.5c17-2.4,28.9-18.1,26.5-35.1l-91.2-652.6 c-2.4-17-18.1-28.9-35.1-26.5l-304.4,42.5c-17,2.4-28.9,18.1-26.5,35.1L323.3,1273.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M474.5,1236.8c1.2,8.7,9.3,14.8,18,13.6l15.8-2.2c8.7-1.2,14.8-9.3,13.6-18l-2.2-15.8 c-1.2-8.7-9.3-14.8-18-13.6l-15.8,2.2c-8.7,1.2-14.8,9.3-13.6,18L474.5,1236.8z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 301.4,
    y: 670.9,
    transform: "matrix(0.9904 -0.1384 0.1384 0.9904 -123.082 72.5034)",
    className: "st52",
    width: 317,
    height: 501.2
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M433.5,775.4c3.8-0.6,7.6-1.1,11.4-1.7c2.4,0.1,4.7,0.1,7.1,0.2c28,1.4,52,21.8,58.3,48.9 c1.7,7.4,2.5,15,3.7,22.5c0.1,0.7,0.3,1.4,0.4,2.2c1.1-0.2,2.1-0.3,3-0.4c4.3-0.8,7.7,0.8,10.4,4c2,2.3,3.1,5,3.6,8.1 c4.6,31.2,9.1,62.4,13.7,93.6c1,6.9-1.5,11.8-7.4,15.3c-45.8,6.7-91.6,13.4-137.3,20.1c-5.1-0.8-8.4-3.8-10.3-8.3 c-0.7-1.7-1.1-3.5-1.4-5.4c-1.8-12.1-3.6-24.3-5.3-36.4c-2.7-18.4-5.3-36.7-8.1-55.1c-0.5-3.3-0.4-6.6,1-9.7 c1.7-3.8,4.4-6.4,8.8-6.8c1-0.1,1.9-0.3,3.1-0.4c-0.8-5.7-1.8-11.2-2.4-16.7c-0.5-4.7-1.2-9.4-0.8-14 c1.9-26.4,14.7-45.4,39-56.4C426.9,777.4,430.2,776.5,433.5,775.4z M414.4,862.1c24.5-3.6,49-7.2,73.6-10.8 c-0.1-0.7-0.1-1.4-0.2-2c-0.8-5.2-1.4-10.5-2.3-15.7c-0.5-3-1.2-6.1-2.3-9c-6.4-16.9-23.9-26.6-42-23.4 c-16.8,3-30.2,18.6-30,36.1c0.1,8.1,1.9,16.2,2.9,24.2C414.2,861.7,414.3,861.9,414.4,862.1z M474.7,930.2 c-0.6-4.3-1.3-8.5-1.8-12.8c-0.1-1.1,0.1-2.4,0.7-3.3c1.8-3.3,2.6-6.8,2.3-10.5c-0.8-8.9-9.1-17.6-20.8-15.2 c-6.9,1.4-11.6,5.1-13.7,11.7c-2.1,6.8-0.4,12.8,4.6,17.9c0.8,0.9,1.5,2.1,1.7,3.3c1.3,8.3,2.5,16.6,3.7,25 c0.7,4.6,3.3,6.6,7.9,5.9c3.8-0.6,7.6-1.1,11.4-1.7c4.5-0.7,6.5-3.3,5.9-7.7C476,938.6,475.3,934.4,474.7,930.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M395.1,1039.4l-6,9.6l0.1,0.2l10.3-3.8l1,6.8l-11-0.2l0,0.2l8.6,7.1l-5.4,4.4l-5.4-9.8l-0.1,0.1 l-2.3,10.9l-6.3-2.6l5.9-9.5l0-0.1l-10.2,3.5l-1-6.8l10.7,0.5l0-0.1l-8.4-7.4l5.5-4.3l5.3,9.7l0.1,0l2.3-10.8L395.1,1039.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M425.5,1034.8l-6,9.6l0.1,0.2l10.3-3.8l1,6.8l-11-0.2l0,0.2l8.6,7.1l-5.4,4.4l-5.4-9.8l-0.1,0.1 l-2.3,10.9l-6.3-2.6l5.9-9.5l0-0.1l-10.2,3.5l-1-6.8l10.7,0.5l0-0.1l-8.4-7.4l5.5-4.3l5.3,9.7l0.1,0l2.3-10.8L425.5,1034.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M456,1030.1l-5.9,9.6l0.1,0.2l10.3-3.8l1,6.8l-11-0.2l0,0.2l8.6,7.1l-5.4,4.4l-5.4-9.8l-0.1,0.1 l-2.3,10.9l-6.3-2.6l5.9-9.5l0-0.1l-10.2,3.5l-1-6.8l10.7,0.5l0-0.1l-8.4-7.4l5.5-4.3l5.3,9.7l0.1,0l2.3-10.8L456,1030.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M486.5,1025.5l-5.9,9.6l0.1,0.2l10.3-3.8l1,6.8l-11-0.2l0,0.2l8.6,7.1l-5.4,4.4l-5.4-9.8l-0.1,0.1 l-2.3,10.9l-6.3-2.6l5.9-9.5l0-0.1l-10.2,3.5l-1-6.8l10.7,0.5l0-0.1l-8.4-7.4l5.5-4.3l5.3,9.7l0.1,0l2.3-10.8L486.5,1025.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M516.9,1020.9l-5.9,9.6l0.1,0.2l10.3-3.8l1,6.8l-11-0.2l0,0.2l8.6,7.1l-5.4,4.4l-5.4-9.8l-0.1,0.1 l-2.3,10.9l-6.3-2.6l5.9-9.5l0-0.1l-10.2,3.5l-1-6.8l10.7,0.5l0-0.1l-8.4-7.4l5.5-4.3l5.3,9.7l0.1,0l2.3-10.8L516.9,1020.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M547.4,1016.2l-6,9.6l0.1,0.2l10.3-3.8l1,6.8l-11-0.2l0,0.2l8.6,7.1l-5.4,4.4l-5.4-9.8l-0.1,0.1 l-2.3,10.9l-6.3-2.6l5.9-9.5l0-0.1l-10.2,3.5l-1-6.8l10.7,0.5l0-0.1l-8.4-7.4l5.5-4.3l5.3,9.7l0.1,0l2.3-10.8L547.4,1016.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M577.9,1011.6l-6,9.6l0.1,0.2l10.3-3.8l1,6.8l-11-0.2l0,0.2l8.6,7.1l-5.4,4.4l-5.4-9.8l-0.1,0.1 l-2.3,10.9l-6.3-2.6l5.9-9.5l0-0.1l-10.2,3.5l-1-6.8l10.7,0.5l0-0.1l-8.4-7.4l5.5-4.3l5.3,9.7l0.1,0l2.3-10.8L577.9,1011.6z"
  }))))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M316.8,1209.6c15.9,15.2,41.1,14.6,56.3-1.3c15.2-15.9,14.6-41.1-1.3-56.3l-84.5-79.5 c-15.9-15.2-41.1-14.6-56.3,1.3c-15.2,15.9-14.6,41.1,1.3,56.3L316.8,1209.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st54"
  }, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000137842470326205457950000007536591970418198659_",
    x: 211.7,
    y: 937.5,
    width: 154,
    height: 144.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134245296445583866750000001104209578130320556_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137842470326205457950000007536591970418198659_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000134245296445583866750000001104209578130320556_)",
      fill: "#C2C0BF"
    },
    d: "M298.2,1072 c17,14.8,42.8,12.9,57.6-4.1c14.8-17,12.9-42.8-4.1-57.6l-72.4-62.8c-17-14.8-42.8-12.9-57.6,4.1c-14.8,17-12.9,42.8,4.1,57.6 L298.2,1072z"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M288.4,1063.2c17,14.8,42.8,12.9,57.6-4.1c14.8-17,12.9-42.8-4.1-57.6l-72.4-62.8 c-17-14.8-42.8-12.9-57.6,4.1c-14.8,17-12.9,42.8,4.1,57.6L288.4,1063.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st54"
  }, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000127017844445326858490000007425299327636413576_",
    x: 222.2,
    y: 836.8,
    width: 111.6,
    height: 111.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170243924626236344520000003515318771817621378_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127017844445326858490000007425299327636413576_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000170243924626236344520000003515318771817621378_)",
      fill: "#C2C0BF"
    },
    d: "M269.5,937.3 c14.8,14.7,38.7,14.7,53.4-0.1c14.7-14.8,14.7-38.7-0.1-53.4l-36.1-36c-14.8-14.7-38.7-14.7-53.4,0.1 c-14.7,14.8-14.7,38.7,0.1,53.4L269.5,937.3z"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M252.4,919.4c14.8,14.7,38.7,14.7,53.4-0.1c14.7-14.8,14.7-38.7-0.1-53.4l-36.1-36 c-14.8-14.7-38.7-14.7-53.4,0.1c-14.7,14.8-14.7,38.7,0.1,53.4L252.4,919.4z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M304.3,881.2C304.3,881.2,304.3,881.1,304.3,881.2l-17.6-17.8c-4.5-4.6-10.5-7-16.4-7.3 c-1.8,4.8-5.4,10.2-10.4,15.2c-5,5-10.5,8.5-15.2,10.3c0.2,6,2.6,11.9,7.1,16.5l17.6,17.7c0,0,0,0,0,0 c3.6,3.6,14.3-1.3,23.9-10.9C302.9,895.4,307.9,884.8,304.3,881.2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M267.7,914.2c5.6-0.8,13.8-5.7,21.5-13.3c7.7-7.6,12.7-15.8,13.5-21.4l1.6,1.6v0c0,0,0,0,0,0 c3.6,3.6-1.4,14.3-11.1,23.8c-9.7,9.6-20.4,14.4-23.9,10.9c0,0,0,0,0,0l0,0L267.7,914.2z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M270.2,856.1c-6.6-0.3-13.3,2.1-18.4,7.1c-5.1,5-7.5,11.7-7.3,18.3c4.8-1.8,10.2-5.3,15.2-10.3 C264.8,866.3,268.4,860.9,270.2,856.1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M337.8,1019.9C337.7,1019.9,337.7,1019.9,337.8,1019.9l-21.7-19.8c-5.6-5.1-12.4-7.9-18.9-8.4 c-1.3,5.1-4.4,10.8-9.2,16.1c-4.8,5.2-10.2,8.9-15.1,10.6c1.1,6.5,4.5,13,10.1,18.1l21.7,19.8c0,0,0,0,0,0 c4.4,4,15.4-0.9,24.5-11C338.3,1035.3,342.1,1023.9,337.8,1019.9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M302.5,1054.5c6-0.7,14.2-5.7,21.5-13.7c7.3-8,11.6-16.7,11.7-22.7l2,1.8l0,0c0,0,0,0,0,0 c4.4,4,0.5,15.4-8.7,25.4c-9.2,10.1-20.1,15-24.5,11c0,0,0,0,0,0l0,0L302.5,1054.5z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M297.1,991.8c-7.2-0.5-14.2,1.8-19,7.1c-4.8,5.3-6.5,12.4-5.3,19.6c5-1.8,10.4-5.4,15.1-10.6 C292.7,1002.6,295.9,996.8,297.1,991.8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M364.9,1167.6C364.9,1167.6,364.8,1167.5,364.9,1167.6l-21.7-19.8c-5.6-5.1-12.4-7.9-18.9-8.4 c-1.3,5.1-4.4,10.8-9.2,16.1c-4.8,5.2-10.2,8.9-15.1,10.6c1.1,6.5,4.5,13,10.1,18.1l21.7,19.8c0,0,0,0,0,0 c4.4,4,15.4-0.9,24.5-11C365.4,1182.9,369.3,1171.6,364.9,1167.6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M329.6,1202.1c6-0.7,14.2-5.7,21.5-13.7c7.3-8,11.6-16.7,11.7-22.7l2,1.8l0,0c0,0,0,0,0,0 c4.4,4,0.5,15.4-8.7,25.4c-9.2,10.1-20.1,15-24.5,11c0,0,0,0,0,0l0,0L329.6,1202.1z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M324.2,1139.4c-7.2-0.5-14.2,1.8-19,7.1c-4.8,5.3-6.5,12.4-5.3,19.6c5-1.8,10.4-5.4,15.1-10.6 C319.8,1150.2,323,1144.5,324.2,1139.4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellphoneSecurity);
export default __webpack_public_path__ + "static/media/cellphone_security.2bdac119a18be4183d11a3cc5e325dd9.svg";
export { ForwardRef as ReactComponent };